import { render, staticRenderFns } from "./UserBlockedProvider.vue?vue&type=template&id=5a420853&scoped=true"
import script from "./UserBlockedProvider.vue?vue&type=script&lang=js"
export * from "./UserBlockedProvider.vue?vue&type=script&lang=js"
import style0 from "./UserBlockedProvider.vue?vue&type=style&index=0&id=5a420853&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a420853",
  null
  
)

export default component.exports